<template>
    <div class="main-content">
        <div v-if="documentData">
            <div class="header-banner-img" style="background-image: url('/assets/img/dax_thumbnail.png');" v-if="documentData.entity_group == 'Dax'"></div>
            <div class="header-banner-img" style="background-image: url('/assets/img/m_thumbnail.png');" v-else-if="documentData.entity_group == 'MCode'"></div>
            <div class="header-banner-img" style="background-image: url('/assets/img/r_thumbnail.png');" v-else-if="documentData.entity_group == 'RAWCode'"></div>
            <div class="header-banner-img" style="background-image: url('/assets/img/r_thumbnail.png');" v-else-if="documentData.entity_group == 'PythonCode'"></div>
            <div class="header-banner-img" style="background-image: url('/assets/img/r_thumbnail.png');" v-else-if="documentData.entity_group == 'RCode'"></div>
            <div class="header-banner-img" style="background-image: url('/assets/img/r_thumbnail.png');" v-else-if="documentData.entity_group == 'Notepad'"></div>
            <div class="header-banner-img" style="background-image: url('/assets/img/planner-board-banner-img.png');" v-else-if="documentData.entity_group == 'Planner'"></div>
            <div class="header-banner-img" style="background-image: url('/assets/img/model_planner_thumbnail.png');" v-else-if="documentData.entity_group == 'Model Planner'"></div>
            <div class="header-banner-img" style="background-image: url('/assets/img/pipeline_thumbnail.png');" v-else-if="documentData.entity_group == 'Pipeline Planner'"></div>
            <div class="header-banner-img" style="background-image: url('/assets/img/priorities-board-banner-img.png');" v-else-if="documentData.entity_group == 'Priorities Matrix'"></div>
            <div class="header-banner-img" style="background-image: url('/assets/img/playlist_play.svg');" v-else-if="documentData.entity_group == 'Playlist'"></div>

            <div class="header-banner-img"
                 v-else-if="documentData.entity_group == 'Portfolio'">
                <PortfolioSlider :pictures="documentData.entity_data.pictures" />
            </div>

            <div style="margin: auto -60px;"  v-else-if="documentData.entity_data && documentData.entity_data.meta.colours">
                <VerticalColourPalette v-bind:colours="documentData.entity_data.meta.colours"
                                       v-bind:count="documentData.entity_data.meta.coloursAmount"
                                       v-bind:height="'200'" />
            </div>
            <div class="header-banner-img" style="background-image: url('/assets/img/header-banner-pic.jpg');" v-else></div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="documents-single" v-if="documentData">
                        <div class="documents-single-header">
                            <like-button :docId="documentData.id" v-if="documentData.id" :viewMode="'doc-view'"></like-button>

                            <div class="documents-shared-right">
                                <span class="btn shared-btn" v-if="documentData.team_shared">TEAM DOCUMENT</span>
                                <span class="btn shared-btn" v-else-if="documentData.shared">SHARED</span>
                                <span class="btn private-btn" v-else>PRIVATE</span>
                                <div class="custom-control custom-switch" v-if="share_permissions && openAccessPlan">
                                    <input type="checkbox" class="custom-control-input" id="SHARED"
                                           :disabled="!share_permissions"
                                           @click="shareDoc($event)"
                                           :checked="documentData.shared">
                                    <label class="custom-control-label" for="SHARED"></label>
                                </div>
                            </div>
                            <div class="documents-title">
                                <h5>
                                    <img src="/assets/img/picture-icon.svg" alt="" v-if="documentData.entity_group == 'Colour Theme'">
                                    <img src="/assets/img/planner-icon.svg" alt="" v-else-if="documentData.entity_group == 'Planner'">
                                    <img src="/assets/img/planner-icon.svg" alt="" v-else-if="documentData.entity_group == 'Model Planner'">
                                    <img src="/assets/img/planner-icon.svg" alt="" v-else-if="documentData.entity_group == 'Pipeline Planner'">
                                    <img src="/assets/img/priorities-grid-icon.svg" alt="" v-else-if="documentData.entity_group == 'Priorities Matrix'">
                                    <img src="/assets/img/priorities-grid-icon.svg" alt="" v-else-if="documentData.entity_group == 'Portfolio'">
                                    <img src="/assets/img/playlist_small_play.svg" alt="" v-else-if="documentData.entity_group == 'Playlist'">
                                    <img src="/assets/img/file-icon.svg" alt="" v-else>
                                    <span  :class="{ 'text-uppercase': documentData.entity_group === 'Dax'}">{{  documentData.entity_group }}</span>
                                    <span class="date">{{ documentData.created_at | moment("D MMMM YYYY") }}</span>
                                </h5>
                                <h1 @click="editNameDesc()" :class="{ 'edit-title': share_permissions}">{{  documentData.name }}</h1>
                                <div class="mb-5" v-if="openAccessPlan">
                                    <router-link class="btn btn-sm-primary" v-if="documentData.entity_name == 'Dax'" :to="{ name: documentData.entity_name, query: {id: documentData.document_id} }">Open Document</router-link>
                                    <router-link class="btn btn-sm-primary" v-else-if="documentData.entity_name == 'MCode' && documentData.user && userId === documentData.user.id" :to="{ name: 'M Code', query: {id: documentData.document_id} }">Open Document</router-link>
                                    <router-link class="btn btn-sm-primary" v-else-if="documentData.entity_name == 'RAWCode' && documentData.user && userId === documentData.user.id" :to="{ name: 'RAW Code', query: {id: documentData.document_id} }">Open Document</router-link>
                                    <router-link class="btn btn-sm-primary" v-else-if="documentData.entity_name == 'PythonCode' && documentData.user && userId === documentData.user.id" :to="{ name: 'PythonCode', query: {id: documentData.document_id} }">Open Document</router-link>
                                    <router-link class="btn btn-sm-primary" v-else-if="documentData.entity_name == 'RCode' && documentData.user && userId === documentData.user.id" :to="{ name: 'RCode', query: {id: documentData.document_id} }">Open Document</router-link>
                                    <router-link class="btn btn-sm-primary" v-else-if="documentData.entity_name == 'Notepad' && documentData.user && userId === documentData.user.id" :to="{ name: 'Notepad', query: {id: documentData.document_id} }">Open Document</router-link>
                                    <router-link class="btn btn-sm-primary" v-else-if="documentData.entity_name == 'Planner' && documentData.user && userId === documentData.user.id" :to="{ name: 'Analytics Planner', params: {doc_id: documentData.document_id} }">Open Document</router-link>
                                    <router-link class="btn btn-sm-primary" v-else-if="documentData.entity_name == 'Model Planner' && documentData.user && userId === documentData.user.id" :to="{ name: 'Data Model Planner', params: {doc_id: documentData.document_id} }">Open Document</router-link>
                                    <router-link class="btn btn-sm-primary" v-else-if="documentData.entity_name == 'Pipeline Planner' && documentData.user && userId === documentData.user.id" :to="{ name: 'Data Pipeline Planner', params: {doc_id: documentData.document_id} }">Open Document</router-link>
                                    <router-link class="btn btn-sm-primary" v-else-if="documentData.entity_name == 'Priorities Matrix' && documentData.user && userId === documentData.user.id" :to="{ name: 'Priorities Matrix', params: {doc_id: documentData.document_id} }">Open Document</router-link>
                                    <router-link class="btn btn-sm-primary" v-else-if="documentData.entity_name == 'Portfolio' && documentData.user && userId === documentData.user.id" :to="{ name: 'Project Share', params: {doc_id: documentData.document_id} }">Open Document</router-link>
                                    <router-link class="btn btn-sm-primary" v-else-if="documentData.entity_name == 'ColourFan'" :to="{ name: 'Colours Fan', query: {id: documentData.document_id} }">Open Document</router-link>
                                    <router-link class="btn btn-sm-primary" v-else-if="documentData.entity_name == 'ColourImage'" :to="{ name: 'Image to Colours', query: {id: documentData.document_id} }">Open Document</router-link>
                                    <router-link class="btn btn-sm-primary" v-else-if="documentData.entity_name == 'ColourPalette'" :to="{ name: 'Colours Palette', query: {id: documentData.document_id} }">Open Document</router-link>
                                    <router-link class="btn btn-sm-primary" v-else-if="documentData.entity_name == 'Playlist'" :to="{ name: 'Playlist', params: {doc_id: documentData.document_id} }">Open Document</router-link>
                                </div>
                                <div class="mb-5" v-if="!openAccessPlan">
                                    <router-link class="btn btn-sm-primary" :to="{ name: 'Subscription Plans' }">Upgrade to view</router-link>
                                </div>


                                <div class="profile-author" v-if="documentData.user">
                                    <div class="user-img">
                                        <avatar :src="'/storage/' + documentData.user.photo" :username="documentData.user.name" v-if="documentData.user && documentData.user.name" :size="44"></avatar>
                                    </div>
                                        <h6>{{ documentData.user.name }}<small v-if="share_permissions"><a @click="editNameDesc" class="edit-comment-link">(Edit)</a></small></h6>
                                </div>
                                <div class="documents-description">
                                    <p v-html="documentData.description" class="tinymce-html"></p>
                                    <p class="project-link"
                                       v-if="documentData.entity_data.link"
                                    >Project Link: <a :href="documentData.entity_data.link" target="_blank">{{ documentData.entity_data.link }}</a></p>
                                </div>
                            </div>
                        </div>
                        <ViewPictures :pictures="documentData.entity_data.pictures" v-if="documentData.entity_data.pictures" />

                        <comments :docId="documentData.id" v-if="documentData.id" :likes_count="totalLikes"></comments>
                    </div>
                    <div class="setting-profile-popup popup-save-document non-app-page-width" v-else-if="unauthorised">
                        <div class="setting-profile-wrapper">
                            <div class="save-document-form">
                                <h2>Unauthorised</h2>
                                <p>
                                    You do not have permission to view the file
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <doc-edit-name v-if="editTitle && documentData"></doc-edit-name>
    </div>
</template>

<script>
import DocumentHttpService from "../services/DocumentHttpService";
import Avatar from 'vue-avatar';
import Comments from "./Comments";
import ApiService from "../api/api.service";
import LikeButton from "./partials/LikeButton";
import VerticalColourPalette from "./partials/VerticalColourPalette";
import ViewPictures from "./ViewPictures";
import DocEditName from "./DocEditName";
import PortfolioSlider from "./PortfolioSlider";

export default {
    name: "DocumentContent",
    components: {
        DocEditName,
        VerticalColourPalette,
        LikeButton,
        Avatar,
        Comments,
        ViewPictures,
        PortfolioSlider
    },
    data: () => {
        return  {
            docService: new DocumentHttpService(),
            documentData: null,
            share_permissions: false,

            userId: null,
            userData: null,
            likeStatus: false,
            totalLikes: 0,
            unauthorised: false,

            openAccessPlan:false,

            editTitle: false,
            title_updated: false,
        };
    },
    mounted() {
        this.setCurrentUser();
        this.loadDoc(this.$route.params.document_id);
    },
    methods: {
        loadDoc(id) {
            this.docService.get(id).then(res => {
                this.documentData = res.data.doc;

                if(this.documentData) {

                    const titleEl = document.querySelector('head title');
                    titleEl.textContent = this.documentData.name + ' - Analyst Hub by Enterprise DNA';

                    // check share permissions
                    this.share_permissions = (this.documentData.user && this.userId == this.documentData.user.id && !this.documentData.team_shared);
                    this.documentData.entity_data = res.data.entity

                    this.openAccessPlan = (!this.userData.free_plan || res.data.doc.latest_three);

                    this.likedByMe();
                } else {
                    this.unauthorised = true;
                }

            }, function (res) {
                console.error(res);
            });
        },

        setCurrentUser() {
            // check share permissions
            this.userData = JSON.parse(localStorage.getItem('user'));
            this.userId = this.userData.id;
        },
        shareDoc($event) {
            ApiService.setHeader();
            ApiService.put('/api/document/share/' + this.documentData.id, { shared: $event.target.checked})
            .then(({data}) => {
                this.documentData.shared = $event.target.checked;
            })
            .catch((res) => {
                console.log(res)
            });
        },

        likedByMe() {
            ApiService.setHeader();
            ApiService.get('/api/document/liked/' + this.documentData.id)
                .then(({data}) => {
                    this.likeStatus = data.data;
                    this.totalLikes = data.total;
                })
                .catch((res) => {
                    console.log(res)
                });
        },

        updateTitle()
        {
            let params = {
                name: this.documentData.name,
                description: this.documentData.description,
                team_shared: this.documentData.team_shared,
                shared: this.documentData.shared,
            };
            ApiService.setHeader();
            ApiService.put('/api/document/rename/' + this.documentData.id, params)
                .then(({data}) => {
                    this.title_updated = true;
                    setTimeout(() => {
                        this.editTitle = false;
                        this.title_updated = false;
                    }, 2000);
                })
                .catch((res) => {
                    console.log(res)
                });
        },

        editNameDesc()
        {
            if(this.documentData.user && this.userId == this.documentData.user.id) {
                this.editTitle = true;
            }
        },

        closePopup()
        {
            this.loadDoc(this.$route.params.document_id);
            this.editTitle = false;
        }
    }

}
</script>


<style scoped>
</style>
